import React, { useEffect, useState } from 'react';

import { useAuthenticator } from '@aws-amplify/ui-react';
import { Dropdown } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { portalForUser } from '../../features/Manuals/portals';
import { fetchActiveManualForPortal, getManualUrl } from '../../utils/manualStorage';
import Button from '../Button';

import './styles.scoped.css';

// CP-785 — end-user download. Clients get the client portal's manual; internal users get
// this environment's configured portal manual. The user's record must load before the
// portal can be resolved (its type decides which manual), so the button waits for it.
// CP-842 — asMenuItem renders the same action as an item in the Header's profile menu.
const DownloadManualButton = ({ asMenuItem = false }) => {
  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  const user = useSelector(state => state.admin.user);
  const [manual, setManual] = useState(null);

  const portal = authStatus === 'authenticated' && user?.id ? portalForUser(user.type) : null;

  useEffect(() => {
    if (!portal) {
      setManual(null);
      return undefined;
    }
    let active = true;
    const load = async () => {
      const found = await fetchActiveManualForPortal(portal);
      if (active) setManual(found);
    };
    load();
    return () => {
      active = false;
    };
  }, [portal]);

  if (!manual) return null;

  const handleDownload = async () => {
    const url = await getManualUrl(manual.documentName);
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (asMenuItem) {
    return (
      <Dropdown.Item as="button" onClick={handleDownload}>
        Download Manual
      </Dropdown.Item>
    );
  }

  return <Button variant="outline" text="Download Manual" onPress={handleDownload} className="download-manual-btn" />;
};

export default DownloadManualButton;
